import * as React from "react";
const SvgFiRrPercent10 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-percent-10_svg__a)">
      <path
        fill="#062147"
        d="M21.122 18.229a1 1 0 0 1 .134 1.408A11.97 11.97 0 0 1 12 24C5.383 24 0 18.617 0 12S5.383 0 12 0c3.592 0 6.966 1.59 9.256 4.363a1 1 0 1 1-1.542 1.274A9.98 9.98 0 0 0 12 2C6.486 2 2 6.486 2 12s4.486 10 10 10a9.97 9.97 0 0 0 7.714-3.637 1 1 0 0 1 1.408-.134M13.5 8a2.5 2.5 0 0 1 2.5 2.5v3a2.5 2.5 0 1 1-5 0v-3A2.5 2.5 0 0 1 13.5 8m0 1.6c-.496 0-.9.404-.9.9v3c0 .496.404.9.9.9s.9-.404.9-.9v-3c0-.496-.404-.9-.9-.9m9.25 3.881a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-3.25-4.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m-1.156 6.75a.8.8 0 0 0 .67-.363l4.178-6.4a.8.8 0 1 0-1.34-.874l-4.178 6.4a.8.8 0 0 0 .67 1.237M9.2 16a.8.8 0 0 0 .8-.8V8.843a.86.86 0 0 0-1.479-.599l-1.63 1.682a.8.8 0 1 0 1.149 1.113l.36-.372v4.532a.8.8 0 0 0 .8.8z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-percent-10_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPercent10;
